import styled from "@emotion/styled";
export const StyledRegularButton = styled.div`
  &.full {
    width: 100%;
  }
  .additional-button-text {
    margin-top: 8px;
  }
`;
